import React from 'react';

class Header extends React.Component {
  render() {
    return <h1 className="center light-blue-text">Tem água hoje?</h1>;
  }
}

export default Header;
